module.exports = __webpack_public_path__ + "img/background.43878e5c.png";